import { render, staticRenderFns } from "./campaignGiftsClaimModal.vue?vue&type=template&id=083a0d84&"
import script from "./campaignGiftsClaimModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./campaignGiftsClaimModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports